import * as api from '../../resources/dictionaries.api';
import actionTypes from './dictionaries.action-types';

export const fetchPricePointsDictionaryRequest = () => ({
  type: actionTypes.FETCH_PRICE_POINTS_DICTIONARY_REQUEST,
});

export const fetchPricePointsDictionarySuccess = (pricePoints) => ({
  type: actionTypes.FETCH_PRICE_POINTS_DICTIONARY_SUCCESS,
  pricePoints,
});

export const fetchPricePointsDictionaryFailure = () => ({
  type: actionTypes.FETCH_PRICE_POINTS_DICTIONARY_FAILURE,
});

export const fetchPricePointsDictionary = () => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;

    dispatch(fetchPricePointsDictionaryRequest());

    const pricePoints = await api.fetchPricePointsDictionary({ locale });
    dispatch(fetchPricePointsDictionarySuccess(pricePoints));
  } catch (error) {
    console.error('PRICE_POINTS_DICTIONARY', error);
    dispatch(fetchPricePointsDictionaryFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/app/actions/dictionaries/price-points-dictionary.actions.js